import React, {Component, createRef} from 'react';
import type {Node} from 'react';
import Box from '@material-ui/core/Box';
import {MediumTooltip} from 'amn/ui/diverse/ToolTips';

type Props = {
  text: string;
  lines?: number;
} & Object;

type State = {
  isTruncated: boolean;
};

class TruncatedText extends Component<Props, State> {
  textRef = createRef();

  static defaultProps = {
    lines: 1
  };

  state = {
    isTruncated: false
  };

  componentDidMount() {
    this.checkTruncation();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.text !== this.props.text || prevProps.lines !== this.props.lines) {
      this.checkTruncation();
    }
  }

  checkTruncation = () => {
    if (this.textRef.current) {
      const {scrollHeight, clientHeight, scrollWidth, clientWidth} = this.textRef.current;
      const isTruncated = scrollHeight > clientHeight || scrollWidth > clientWidth;
      if (this.state.isTruncated !== isTruncated) {
        this.setState({isTruncated});
      }
    }
  };

  render() {
    const {text, lines, ...boxProps} = this.props;
    const {isTruncated} = this.state;

    if (!text) {
      return null;
    }

    const content = this.renderContent(text, lines, boxProps);

    if (isTruncated) {
      return this.renderTooltip(text, content);
    }

    return content;
  }

  renderContent = (text: string, lines: number, boxProps: Object) => {
    const style = lines === 1 ? {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      wordBreak: "break-all"
    } : {
      display: "-webkit-box",
      WebkitLineClamp: lines,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      wordBreak: "break-word"
    };

    return (
      <Box ref={this.textRef}
           style={style}
           {...boxProps}>
        {text}
      </Box>
    );
  }

  renderTooltip = (text: string, content: Node) => {
    return (
      <MediumTooltip title={text}
               interactive>
        <Box>
          {content}
        </Box>
      </MediumTooltip>
    );
  }
}

export default TruncatedText;
